import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import PendingReferralsList from './PendingReferralsList';
import '@medprompt/shared/src/common/modals.css';
import './PendingReferralsModal.css';

/**
 * Proactive "pending referrals" popup that appears once per document per session
 * when a document is opened and its patient has outstanding referrals.
 *
 * Fired by DocumentDetailViewController using a viewersWarningShownRef-style ref/Set.
 */
const PendingReferralsModal = ({ referrals = [], onReferralClick, onDismiss }) => {
  if (!referrals || referrals.length === 0) return null;

  return (
    <div className="modal-overlay" onClick={onDismiss}>
      <div
        className="modal-container pending-referrals-modal modal-animated"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <div className="pending-referrals-modal-title">
            <h2>Pending Referrals</h2>
            <span className="pending-referrals-count-badge">{referrals.length}</span>
          </div>
          <button className="close-button" onClick={onDismiss}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="modal-content pending-referrals-modal-content">
          <p className="pending-referrals-intro">
            This patient has {referrals.length} pending referral{referrals.length !== 1 ? 's' : ''}.
            Select one to review or mark as complete.
          </p>
          <PendingReferralsList referrals={referrals} onReferralClick={onReferralClick} />
        </div>

        <div className="modal-actions">
          <button className="cancel-button" onClick={onDismiss}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingReferralsModal;
